export default __webpack_public_path__ + "static/media/acceZ.973cbec6.svg";